import { hexToRgb, getTextColorForBackground, generateColorTheme } from './colorHelpers'

const CSS_VARS = [
  '--default-bg',
  '--selected-fill',
  '--selected-fill-10',
  '--selected-fill-15',
  '--selected-stroke',
  '--avatar',
  '--editor-top',
  '--overlay-color',
  '--editor-bg',
  '--focus-50',
  '--whitelabel-brand',
] as const

const generateWhiteLabelStyles = (brandColor: string, textColor: string) => `
[data-whitelabel='true'] input[type='checkbox'][class*='ToggleButton_checkbox__']:checked + label {
  background-color: ${brandColor} !important;
}

[data-whitelabel='true'] button[class*='Button_primary__']:not([class*='primary-colored']):not([disabled]),
[data-whitelabel='true'] a[class*='Button_primary__']:not([class*='primary-colored']),
[data-whitelabel='true'] button[class*='Button_blazePrimary__']:not([disabled]),
[data-whitelabel='true'] a[class*='Button_blazePrimary__'],
[data-whitelabel='true'] button[class*='Button_blazeSecondary__']:not([disabled]),
[data-whitelabel='true'] a[class*='Button_blazeSecondary__'],
[data-whitelabel='true'] button[class*='MobileButton_mobileButton__']:not([class*='secondary']):not([class*='tertiary']):not([disabled]) {
  background: ${brandColor} !important;
  color: ${textColor} !important;
}

[data-whitelabel='true'] button[class*='Button_blazePrimary__']:not([disabled]),
[data-whitelabel='true'] a[class*='Button_blazePrimary__'],
[data-whitelabel='true'] button[class*='Button_blazeSecondary__']:not([disabled]),
[data-whitelabel='true'] a[class*='Button_blazeSecondary__'] {
  border-color: ${brandColor} !important;
}

[data-whitelabel='true'] button[class*='Button_primary__']:not([class*='primary-colored']) [class*='Icon_'],
[data-whitelabel='true'] a[class*='Button_primary__']:not([class*='primary-colored']) [class*='Icon_'],
[data-whitelabel='true'] button[class*='Button_blazePrimary__'] [class*='Icon_'],
[data-whitelabel='true'] button[class*='Button_blazeSecondary__'] [class*='Icon_'],
[data-whitelabel='true'] button[class*='MobileButton_mobileButton__']:not([class*='secondary']):not([class*='tertiary']) [class*='Icon_'] {
  color: ${textColor} !important;
}

[data-whitelabel='true'] button[class*='Button_ghost-tertiary__'] [class*='Icon_'],
[data-whitelabel='true'] a[class*='Button_ghost-tertiary__'] [class*='Icon_'] {
  color: var(--selected-fill) !important;
}

[data-whitelabel='true'] button[class*='Button_primary__'][class*='hovered']:not([class*='primary-colored']),
[data-whitelabel='true'] button[class*='Button_blazePrimary__']:hover,
[data-whitelabel='true'] button[class*='Button_blazeSecondary__']:hover,
[data-whitelabel='true'] button[class*='MobileButton_mobileButton__']:not([class*='secondary']):not([class*='tertiary']):hover {
  opacity: 0.9;
  filter: brightness(0.95);
}

[data-whitelabel='true'] button[class*='Button_primary__'][class*='pressed']:not([class*='primary-colored']):after,
[data-whitelabel='true'] button[class*='Button_primary__'][class*='focused']:not([class*='primary-colored']):after {
  background: transparent !important;
}
`

let lastAppliedColor: string | null = null

export const applyWhiteLabelColor = (color: string): void => {
  if (lastAppliedColor === color) return
  if (!hexToRgb(color)) return

  lastAppliedColor = color
  const theme = generateColorTheme(color)
  const textColorHex = getTextColorForBackground(color) === 'white' ? '#FFFFFF' : '#000000'

  document.documentElement.setAttribute('data-whitelabel', 'true')

  const { style } = document.documentElement
  const cssVars: Record<string, string> = {
    '--default-bg': theme.defaultBg,
    '--selected-fill': theme.selectedFill,
    '--selected-fill-10': theme.selectedFill10,
    '--selected-fill-15': theme.selectedFill15,
    '--selected-stroke': theme.selectedStroke,
    '--avatar': theme.avatar,
    '--editor-top': theme.editorTop,
    '--overlay-color': theme.overlayColor,
    '--editor-bg': theme.editorBg,
    '--focus-50': theme.selectedFill,
    '--whitelabel-brand': color,
  }

  Object.entries(cssVars).forEach(([prop, val]) => style.setProperty(prop, val))

  let styleEl = document.getElementById('white-label-style') as HTMLStyleElement
  if (!styleEl) {
    styleEl = document.createElement('style')
    styleEl.id = 'white-label-style'
    document.head.appendChild(styleEl)
  }
  styleEl.textContent = generateWhiteLabelStyles(color, textColorHex)
}

export const removeWhiteLabelColor = (): void => {
  lastAppliedColor = null
  document.documentElement.removeAttribute('data-whitelabel')
  document.getElementById('white-label-style')?.remove()
  CSS_VARS.forEach((v) => document.documentElement.style.removeProperty(v))
}
